import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBrandContextOperationsResponse } from './admin-brand-context-operations.response';
import { AdminBrandStatus } from '../../enums/admin-brand-status';

@jsonObject
export class AdminBrandCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly homeUrl?: Nillable<string>;

  @jsonMember(MultimediaResponse)
  public readonly logo!: MultimediaResponse;

  @jsonMember(String)
  public readonly status!: AdminBrandStatus;

  @jsonMember(AdminBrandContextOperationsResponse)
  public readonly contextOperations!: AdminBrandContextOperationsResponse;
}
